import * as React from "react";
import { styled } from "@mui/system";
import MUIAppBar, { AppBarProps } from "@mui/material/AppBar";

interface AppBarPropsExtended extends AppBarProps {
  open?: boolean;
}

export const AppBar: (props: AppBarPropsExtended) => JSX.Element = styled(
  React.forwardRef<HTMLDivElement, AppBarPropsExtended>((props, ref) => (
    <MUIAppBar ref={ref} {...props} />
  )),
  {
    name: "AppBar",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)<AppBarPropsExtended>(({ theme }) => ({
  "&.MuiAppBar-root.MuiAppBar-positionFixed": {
    bottom: 0,
    top: "unset"
  }
}));
